module.exports = __webpack_public_path__ + "img/head-wrinkles.3dffddef.svg";